const form = document.getElementById("RegisterForm");
const content = document.querySelector("main#MainContent .page-width");
const submitBtn = document.querySelector("#RegisterForm>p input");
const fields = document.querySelectorAll("#RegisterForm .field:not(.RegisterForm-LastName)");
fields.forEach(field => {
    const label = field.querySelector("label");
    if (label) label.innerHTML += "<span style='color:#c10000'>*</span>";
})
if (submitBtn) {
    submitBtn.setAttribute("style", "margin-bottom: 0px !important");
    submitBtn.value = "COMPLETE YOUR PRO APPLICATION";
}
if (content) content.classList.add("container");
if (form) form.insertAdjacentHTML("beforeend", "<p class='form-footer-desc'>Questions? Email us at <a href='mailto:proaccounts@FiftyFlowers.com'>proaccounts@FiftyFlowers.com</a> </p>")